MS = window.MS || {};
(function($, _u) {
  MS.tableandsalt_recipe = {
    selectors: {
      recipeModule: 'ms-ts-recipe',
      recipeDropdown: 'ms-ts-recipe__dropdown',
      pinkSaltRecipeDropdown: 'ms-ts-recipe__dropdown--pink-salt',
      recipeSelected: 'ms-ts-recipe__dropdown--selected',
      cta: 'ms-ts-recipe__cta',
      carousel: {
        slider: 'ms-ts-slider',
        slide: 'ms-ts-slide',
        slideCount: 'carousel__count',
        arrowsWrapper: 'ms-ts-carousel__arrows',
        arrows: 'ms-ts-recipe__carousel__arrows__dir',
        prevArrow: 'arrow-prev',
        nextArrow: 'arrow-next',
        counter: 'ms-ts-circulation__carousel__counter',
        total: 'total',
        current: 'current',
        cta: 'carousel-slide-cta',
        initialized: 'slick-initialized'
      }
    },
    init: function() {
      this.recipeCarousel();
      this.initRecipeFinder();
      this.recipeSelect();
      this.eventHandler();
      this.countCardsPerPage();
    },
    recipeCarousel: function() {
      var slideCount = null;
      var _this = this;
      var $slider = null;
      // call slick function
      $('.' + _this.selectors.carousel.slider).each(function() {
        var $slider = $(this);
        _this.initSlider($slider);
      });
    },
    initSlider: function($slider, _cardsPerPage) {
      var _prevArrowEl = $( '.' + this.selectors.carousel.prevArrow, $slider.next() );
      var _nextArrowEl = $( '.' + this.selectors.carousel.nextArrow, $slider.next() );
      var _counterEl;
      var counter = {};
      var counterEnabled = $slider.data('counter');

      _cardsPerPage = _cardsPerPage || 1;
      // slick function for recipe carousel
      $slider
        .on('init', function(slick, currentSlide){
          if(!counterEnabled) { return; }
          counter = {
            curr: currentSlide.currentSlide + 1,
            total: currentSlide.slideCount
          };
          // create slider counter element
          _prevArrowEl.after('<div class="' + MS.tableandsalt_recipe.selectors.carousel.counter + '"></div>');
          _counterEl = $( '.' + MS.tableandsalt_recipe.selectors.carousel.counter, $slider.next() );
          updateCounter(counter.curr, counter.total);
        })
        .slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: parseInt(_cardsPerPage),
          slidesToScroll: parseInt(_cardsPerPage),
          arrows: true,
          prevArrow: _prevArrowEl,
          nextArrow: _nextArrowEl,
          initialSlide: 0
        })
        .on('afterChange', function(slick, currentSlide){
          counter = {
            curr: currentSlide.currentSlide + 1,
            total: currentSlide.slideCount
          };
          updateCounter(counter.curr, counter.total);
        });

      // helper
      function updateCounter (currSlide, totalSlides) {
        if(!counterEnabled) { return; }
        return _counterEl.text(currSlide + '/' + totalSlides);
      };
    },
    eventHandler: function() {
      var _this = this;
      window.addEventListener('resize', function() {
        this.setTimeout(function() {
          _this.countCardsPerPage();
        }, 300)
      });
    },
    // Calculates how many cards per page the slider can show.
    countCardsPerPage: function() {
      var _this = this;
      var $slides = $('.' + this.selectors.carousel.slider);
      var $s = $slides.first();
      var $card = $('.' + this.selectors.carousel.slide, $s).first();
      var _paddingLeft = parseInt($s.css('paddingLeft'));
      var _itemWidth = $card.width();
      var _itemMargin = parseInt($card.css('marginRight'));
      var _windowWidth = $(window).width();
      var _cardsPerPage = Math.floor(
        (_windowWidth - _paddingLeft) / (_itemWidth + _itemMargin)
      );

      // Remove default arrow attribute
      $(
        '.' +
          this.selectors.carousel.prevArrow +
          ', .' +
          this.selectors.carousel.nextArrow
      ).removeAttr('style');

      // Limit maximum cards per page to 4
      if (_cardsPerPage >= 4) {
        $slides.attr('data-slides-to-show', 3);
        var _carouselWidth = $s.outerWidth();
        var _containerWidth = _carouselWidth - _paddingLeft + $card.width();
        var _offset = (_windowWidth - _carouselWidth) / 2;
        var _maxWidth = _carouselWidth + _offset - 20;

        // Check if wrapper can hold upto 4 items
        if (_maxWidth > _containerWidth) {
          _cardsPerPage = 4;
        } else {
          _cardsPerPage = 3;
        }
      }

      $slides.attr('data-slides-to-show', _cardsPerPage);
      // Update slider options based from the calculated number of cards per page
      $slides.each(function() {
        var $this = $(this);

        // Checker to make sure the slick is already initialized;
        if ($this.hasClass(_this.selectors.carousel.initialized)) {
          $this.slick(
            'slickSetOption',
            {
              slidesToShow: _cardsPerPage,
              slidesToScroll: _cardsPerPage
            },
            true
          );
        } else {
          _this.initSlider($this, $this.attr('data-slides-to-show'));
        }
      });
    },
    initRecipeFinder: function() {
      var _this = this;
      var $recipeFinderModule = $('.' + _this.selectors.recipeModule);
      var isPinkSalt = $(
        '.' + _this.selectors.pinkSaltRecipeDropdown,
        $recipeFinderModule
      );

      if ($recipeFinderModule.length > 0) {
        var $field = $(
          '.' + _this.selectors.recipeDropdown,
          $recipeFinderModule
        );
        // Select first item as default.
        $field.prop('selectedIndex', 0);
        $field.on('change', function() {
          var recipe_book_id = $field.val();
          // Ajax starts here
          $.ajax({
            url: '/ajax/ts_fetch_recipes/',
            type: 'post',
            data: {
              recipe_book_id: recipe_book_id,
              posts_per_page: isPinkSalt ? 6 : 15
            },
            beforeSend: function() {
              MS.loader.show();
            },
            success: function(result) {
              var result = JSON.parse(result);
              var $slider = $(
                '.' + _this.selectors.carousel.slider,
                $recipeFinderModule
              );
              // remove slider
              $slider.slick('unslick');
              $slider.html(result.html);
              // reinitiate slider
              _this.initSlider($slider, $slider.attr('data-slides-to-show'));
              // Update CTA URL
              $('.' + _this.selectors.cta + ' a', $recipeFinderModule).attr(
                'href',
                result.url
              );
              MS.loader.hide();
            }
          });
          // ajax ends here
        });
      }
    },
    recipeSelect: function() {
      var $recipeDropdown = $('.' + this.selectors.recipeDropdown);
      var initTextRecipe = $(
        '.' + this.selectors.recipeDropdown + ' option:selected'
      ).text();
      var $recipeSelected = $('.' + this.selectors.recipeSelected);
      $recipeSelected.text(initTextRecipe);
      $recipeDropdown.change(function() {
        var str = '';
        $('select.ms-ts-recipe__dropdown option:selected').each(function() {
          str += $(this).text() + '';
        });
        $recipeSelected.text(str);
      });
    }
  };
})(jQuery, utilities);
